import { callFn, db } from "@/infra/cloud-adapter/client";

export interface AccessClaims { tenant_id: string | null; roles: string[]; duties: string[]; is_admin: boolean; actor_kind: "human" | "support"; }
export interface AccessSettings {
  roles: Array<{ id: string; name: string; duties: string[] }>;
  groups: Array<{ id: string; name: string }>;
  mappings: Array<{ group_id: string; role_id: string }>;
  people: Array<{ user_id: string; email: string }>;
  admins: Array<{ user_id: string; email: string }>;
  members: Array<{ group_id: string; user_id: string }>;
  support: Array<{ user_id: string; email: string }>;
  grants: Array<{ id: string; support_user_id: string; created_at: string; expires_at: string; revoked_at: string | null }>;
}
export async function getAccessClaims(): Promise<AccessClaims> {
  const { data, error } = await db().rpc("access_claims");
  if (error) throw error;
  return data as unknown as AccessClaims;
}
export const getAccessSettings = (tenant_id: string) => callFn<AccessSettings>("access-settings", { tenant_id });
export const changeAccess = (tenant_id: string, operation: string, input: Record<string, unknown>) => callFn<{ ok: boolean }>("access-change", { tenant_id, operation, input });
export async function recordSupportRead(t: string, page: string) { const { error } = await db().rpc("record_support_read", { t, page }); if (error) throw error; }
